function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#E11F3D",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M10.162 10.1c.388.15.988.4 1.413.575-.612.262-3.3 1.55-4.287 2.137a15.48 15.48 0 0 0-1.388-.65c2.075-1.212 4.225-2.012 4.262-2.062zm-1.8-.662c.425.124.775.3 1.213.4-.612.262-3.275 1.45-4.275 2.025-.438-.175-.8-.3-1.3-.488C6.075 10.187 8.325 9.5 8.363 9.437z",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M18.55 10.537c.637.275.938.488 1.45.775-.613.263-5.725 2.7-8.2 4.863-.45-.263-1.438-1.013-1.9-1.25 1.987-1.288 4.512-3.138 8.65-4.388zM16.4 9.45c.638.275 1.063.513 1.625.763-.612.262-4.825 1.625-8.812 4.275-.5-.313-1.325-.775-1.813-.938 2.075-1.213 4.813-3.025 9-4.1zm-6.8-.9c1.088.35 2.688.912 3.725 1.438-.325.175-.775.3-1.175.462C9.5 9.338 8.425 9.012 8.375 8.975c.25-.1 1.025-.35 1.225-.425zm1.938-.488c1.087.35 2.75.825 3.8 1.363-.35.087-.863.188-1.275.362-2.65-1.112-3.626-1.4-3.676-1.437.238-.1.95-.225 1.15-.287z"
}));

var SvgIcBoa = function SvgIcBoa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBoa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_boa.016b1189.svg";
export { ForwardRef as ReactComponent };